export default "__VITE_ASSET__d2e0e087__"